(function () {

    let term_ids = [];

    const filter_buttons = document.querySelectorAll('button.filter');

    filter_buttons.forEach((filter_button) => {

        filter_button.addEventListener('click', (e) => {

            const term_id = filter_button.getAttribute('data-term-id');

            if (term_ids.includes(term_id)) {
                term_ids = term_ids.filter(id => id !== term_id);
                filter_button.classList.remove('active');

            } else {
                term_ids.push(term_id);
                filter_button.classList.add('active');
            }

            get_posts_by_term_id();







        })

    });


    const get_posts_by_term_id = () => {
        document.querySelector('.loader-area').classList.add('show');
        document.querySelector('ul.posts-list').style.display = 'none';


        let form_data = new FormData();

        form_data.append('action', 'get_posts_by_term_id');
        form_data.append('term_ids', term_ids.join(','));

        fetch(my_ajax_object.ajax_url, {
            method: 'POST',
            body: form_data
        }).then(response => response.json())
            .then(data => {
                document.querySelector('ul.posts-list').style.display = 'grid';
                document.querySelector('.loader-area').classList.remove('show');
                document.querySelector('ul.posts-list').innerHTML = data;
            });
    }
}());